<div class="title">{{ title }}</div>
<div class="subtitle">{{ description }}</div>

<div class="settings">
  @if (!loading) {
    <div class="row center">
      <mat-button-toggle-group name="availabilityIncrements" [formControl]="durationFormControl">
        @for (option of options; track option) {
          <mat-button-toggle class="setting-toggle" [value]="option.seconds">
            {{ option.label }}
          </mat-button-toggle>
        }
      </mat-button-toggle-group>
    </div>
    <div class="row center">
      <p class="hint">{{ hint }}</p>
    </div>
  } @else {
    <div class="row center">
      @for (option of options; track option) {
        <div
          class="increment-box stencil-shimmer increment-box__loading--stencil-shimmer"
          >
          <div class="invisible">
            <span>{{ option.label }}</span>
          </div>
        </div>
      }
    </div>
    <div class="row center">
      <p class="hint">{{ hint }}</p>
    </div>
  }
</div>
